import { VSkeletonLoader, VCol } from 'vuetify/lib';
import './styles.css';

export default {
  functional: true,
  render(_, context) {
    const { withoutMedia, isCard, loading, isTechGuide } = context.props || {};
    if (!loading) {
      return context.children;
    }
    return (
      <div
        class={[
          'd-flex flex-wrap card-media-skeleton-root',
          isCard && 'card-media-skeleton-card',
          isTechGuide && 'card-media-tech-guide-skeleton-card',
        ]}
      >
        {!withoutMedia && (
          <div class="card-media-skeleton-image-wrapper">
            <VSkeletonLoader
              loading={true}
              type="image"
              class="card-media-skeleton-image"
            />
          </div>
        )}
        <div class="card-media-skeleton-content-wrapper">
          <VSkeletonLoader
            loading={true}
            type="chip"
            class="mb-5 card-media-skeleton-chip"
          />
          <VSkeletonLoader
            loading={true}
            type="paragraph"
            class="card-media-skeleton-content"
          />
        </div>
      </div>
    );
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    withoutMedia: {
      type: Boolean,
      default: false,
    },
    isCard: {
      type: Boolean,
      default: false,
    },
    isTechGuide: {
      type: Boolean,
      default: false,
    },
  },
};
